import printBatchComponent from './print_batch.component';

let printBatchModule = angular.module('printBatch', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/shipmentBatch')

        $stateProvider.state('printBatch', {
            url: '/print-batch',
            component: 'printBatch',
            data: {
                requireLogin: true,
                requireACL: 'shipment_batch.all'
            },
        })

    })

    .component("printBatch", printBatchComponent)

    .name;

export default printBatchModule;



// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/print/index.js